import { Button, Card } from "antd";
import Avatar from "antd/lib/avatar/avatar";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Logo from "../../../../components/Logo/Logo";
import { AppManager } from "../../../../manager";
import { DealerGroup } from "../../../../models/Organization/DealerGroup";
import { Organization } from "../../../../models/Organization/Organization";
import { RootState } from "../../../../redux/reducers";
import AppLoadingPage from "../../../AppLoadingPage/AppLoadingPage";
import AppSimplePage from "../../../AppSimplePage/AppSimplePage";
import Styles from "./OrgAuthorize.scss";

const ErrorDisplay: React.FC<{ text: string }> = ({ text }) => {
    const handleReloadPage = () => {
        window.location.reload();
    };
    return (
        <div className={Styles.ErrorContainer}>
            <div className={Styles.ErrorTitle}>Error!</div>
            <div className={Styles.ErrorText}>{text}</div>
            <div>
                Try{" "}
                <Button size="small" onClick={handleReloadPage}>
                    Reloading
                </Button>{" "}
                the page. If that does not help, please contact technical support with a screenshot of this error
            </div>
        </div>
    );
};

const NoOrgDisplay = () => {
    return (
        <div className={Styles.ErrorContainer}>
            <div className={Styles.ErrorTitle}>Sorry!</div>
            <div className={Styles.ErrorText}>You currently do not belong to any organization or dealer groups and hence cannot use Ausplan.</div>
            <div>If you think there is something wrong, please contact technical support</div>
        </div>
    );
};

const SelectOrganizationView: React.FC<{ onSelectOrg: (org: Organization | DealerGroup) => void }> = ({ onSelectOrg }) => {
    const userOrgs = useSelector<RootState, Organization[]>((state) => state.orgs.orgs);
    const userDGroups = useSelector<RootState, DealerGroup[]>((state) => state.dealerGroups.orgs);
    return (
        <div className={Styles.OrgsViewContainer}>
            <div className={Styles.SelectOrgTitle}>Select Organization</div>
            <div className={Styles.SelectOrgDesc}>You currently belong to these organizations. Please select one to proceed.</div>
            <div className={Styles.OrgListContainer}>
                {userOrgs.map((t) => (
                    <div key={t.id} className={Styles.OrgItemContainer} onClick={() => onSelectOrg(t)}>
                        <Logo imgStyle={{ width: 80 }} />
                        <div className={Styles.Text}>{t.data.attrs.name}</div>
                    </div>
                ))}
                {userDGroups.map((t) => (
                    <div key={t.id} className={Styles.OrgItemContainer} onClick={() => onSelectOrg(t)}>
                        <Logo imgStyle={{ width: 80 }} orgType="dealerGroup" />
                        <div className={Styles.Text}>{t.data.attrs.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

type OrgType = Organization | DealerGroup;
export default () => {
    const userDataLoaded = useSelector<RootState, boolean>((state) => state.user.userLoaded);
    const activeOrg = useSelector<RootState, OrgType | undefined>((state) => state.orgs.activeOrg || state.dealerGroups.activeOrg);
    const userOrgs = useSelector<RootState, OrgType[]>((state) => [...state.orgs.orgs, ...state.dealerGroups.orgs]);
    const [loading, setLoading] = useState(!userDataLoaded);
    const location = useLocation();
    const [loadError, setLoadError] = useState<string>();
    const handleSetActiveOrg = (org: OrgType) => {
        if (org instanceof Organization) {
            console.log("Organization", org)
            AppManager.route.gotoDefaultOrganization(org.id);
        } else if (org instanceof DealerGroup) {
            console.log("Dealer Group", org)
            AppManager.route.gotoDealerGroupOrganization(org.id);
        }
    };
    useEffect(() => {
        if (!userDataLoaded) {
            AppManager.user.apiFetchUserData((err) => {
                setLoading(false);
                if (err) setLoadError(err);
                else {
                    const persistedOrg = AppManager.org.getPersistedActiveOrg();
                    const persistedDgroup = AppManager.dGroup.getPersistedActiveOrg();
                    if (persistedOrg || persistedDgroup) handleSetActiveOrg(persistedOrg || persistedDgroup);
                    else {
                        const orgs = [...AppManager.org.getUserOrgs(), ...AppManager.dGroup.getUserOrgs()];
                        console.log("ORGS ", orgs);
                        if (orgs.length === 1) handleSetActiveOrg(orgs[0]);
                    }
                }
            });
        }
    }, [userDataLoaded]);

    return loading || userOrgs.length == 1 ? (
        <AppLoadingPage loadingText={userOrgs.length == 1 ? "Redirecting to your portal..." : undefined} />
    ) : loadError ? (
        <AppSimplePage content={<ErrorDisplay text={loadError} />} />
    ) : !userOrgs.length ? (
        <AppSimplePage content={<NoOrgDisplay />} />
    ) : !activeOrg ? (
        <AppSimplePage content={<SelectOrganizationView onSelectOrg={handleSetActiveOrg} />} />
    ) : (
        <div>Hmmm... Something is not right</div>
    );
};
